module.exports = __webpack_public_path__ + "img/9db1f1bd6298e8c71eb49a33051e60ed.png";